import "../assets/scss/TransparentWordList.scss";

import * as classNames from "classnames";
import { observer } from "mobx-react";
import * as React from "react";

import { ILoanWordsStore, WordFilter } from "../stores/word/LoanWordsStore";
import { Word } from "../stores/word/Word";
import { TransparentButton } from "./TransparentButton";

interface Props {
  filter: WordFilter;
  wordStore: ILoanWordsStore;
  onClickOriginalWord: (word: Word) => void;
}

@observer
export class TransparentWordList extends React.Component<Props, undefined> {
  render() {
    const isFilteringByLanguage = !!this.props.filter.originalLanguage;
    const includeLanguage = !isFilteringByLanguage;

    return (
      <div className="transparent-list-well">
        <div
          className={classNames(
            "transparent-list-word-table-header",
            "transparent-list-header-text"
          )}
        >
          {this.renderWordHeader(includeLanguage)}
        </div>
        <div className="transparent-list-word-table-body">
          {this.renderWordList(includeLanguage)}
        </div>
      </div>
    );
  }

  private renderWordHeader(includeLanguage: boolean) {
    return (
      <div className="transparent-list-table">
        <div className="transparent-list-table-row">
          <div className="transparent-list-table-column">Original word</div>
          <div className="transparent-list-table-column">Word</div>
          {includeLanguage && (
            <div className="transparent-list-table-column">Origin language</div>
          )}
        </div>
      </div>
    );
  }

  private renderWordList(includeLanguage: boolean) {
    const sortedWords = this.props.wordStore.getWordsNotFilteredByWord(
      this.props.filter
    );

    return (
      <div className="transparent-list-table">
        {sortedWords.map(word => (
          <div className="transparent-list-table-row">
            <div
              className={classNames(
                "transparent-list-table-column",
                "clickable"
              )}
            >
              <TransparentButton onClick={() => this.onClickOriginalWord(word)}>
                {word.originalWord}
              </TransparentButton>
            </div>
            <div className="transparent-list-table-column">
              <TransparentButton>{word.word}</TransparentButton>
            </div>
            {includeLanguage && (
              <div className="transparent-list-table-column">
                <TransparentButton>{word.originalLanguage}</TransparentButton>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  private onClickOriginalWord = (word: Word) => {
    this.props.onClickOriginalWord(word);
  };
}



// WEBPACK FOOTER //
// ./components/TransparentWordList.tsx